import React from 'react';
import styled from 'styled-components';
import { ListItemProps } from './AppraisalPrice';
import { ReportFormatNumber } from '../../../../func/Function';
import ListContent, { ListData } from '../ListContent';

interface Props {
  landSaleList: [
    { totalAreaPyeong: number; totalAreaMeter: number; appraisalPrice: number },
    {
      list: ListItemProps[];
      isLandRight: boolean;
    },
  ];
  onClose: () => void;
}

function LandSaleModal({ landSaleList, onClose }: Props) {
  const landListData = (item: any, index: any): ListData[] =>
    landSaleList[1].isLandRight
      ? [
          {
            label: '구분',
            value: index + 1,
          },
          {
            label: '면적',
            value: Number(item.areaMeter).toFixed(1),
            isArea: true,
            value_p: Number(item.areaPyeong).toFixed(1),
            hasToggleButton: true,
          },
          {
            label: 'm²당 단가(공시지가)',
            value: ReportFormatNumber(item.appraisePricePerMeter),
          },
          {
            label: '감정가',
            value: ReportFormatNumber(Number(item.appraisePrice)),
          },
        ]
      : [
          {
            label: '구분',
            value: index + 1,
          },
          {
            label: '지번',
            value: item.saddr,
          },
          {
            label: '용도/구조/면적/토지이용계획',
            value: `${item.status ?? '-'} 
  ${Number(item.areaMeter).toFixed(1)}m²(${Number(item.areaPyeong).toFixed(
    1,
  )}평)`,
          },
          {
            label: 'm²당 단가(공시지가)',
            value: ReportFormatNumber(item.appraisePricePerMeter),
          },
          {
            label: '감정가',
            value: ReportFormatNumber(Number(item.appraisePrice)),
          },
        ];
  return (
    <Container>
      <Header>
        <Icon onClick={onClose}>
          <img src="/assets/images/close/close_black-big.svg" alt="" />
        </Icon>
        <HeaderTitle>토지 감정가</HeaderTitle>
        <Icon />
      </Header>
      <Content>
        <Title>
          <img src="/assets/images/icon/forest.svg" alt="" />
          토지 감정가
        </Title>
        <ListItemColorBox>
          <ListItem>
            <span>면적소계</span>
            {landSaleList[0].totalAreaMeter.toFixed(1)}m² (
            {landSaleList[0].totalAreaPyeong.toFixed(1)}평)
          </ListItem>
          <ListItem>
            <span>감정가소계</span>
            {ReportFormatNumber(landSaleList[0].appraisalPrice)}
          </ListItem>
        </ListItemColorBox>

        <Data>
          {landSaleList[1].list.map((item: any, index: any) => (
            <ListContent data={landListData(item, index)} />
          ))}
        </Data>

        <BackButtonContainer>
          <Divider />
          <BackButton onClick={onClose}>상세페이지로 돌아가기 {'>'}</BackButton>
          <Divider />
        </BackButtonContainer>
      </Content>
    </Container>
  );
}

export default LandSaleModal;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom-width: 1px;
  padding: 6px;
`;

const Icon = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
`;

const Content = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f7f7f9;
`;

const BackButton = styled.button`
  border-radius: 9999px;
  padding: 8px 20px;
  background: #f7f7f9;
  border: none;
  white-space: nowrap;

  font-weight: 500;
  font-size: 12px;
  color: #4e5968;
`;

const Title = styled.div`
  display: flex;
  gap: 4px;
  font-weight: 500;
  font-size: 14px;
  align-items: center;
`;

const ListItemColorBox = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 10px 16px;
  gap: 8px;
  background: #f7f8fc;
`;

const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  gap: 8px;

  span {
    font-size: 12px;
    color: #616161;
  }
`;

const Data = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const DataSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const DataListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  text-align: end;
  gap: 8px;

  span {
    white-space: nowrap;
    text-align: start;
    font-size: 13px;
    color: #616161;
  }
`;
